var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('q-icon',{staticClass:"animate-spin items-center icon",staticStyle:{"font-size":"2rem","font-weight":"bold"},attrs:{"name":"autorenew"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }